module.exports = __webpack_public_path__ + "static/specialsPlaceholder-c2460b518220dd3568726bc2a02cacb3.jpg";